let cache;

export default function isMobile() {
    if (cache === undefined) {
        cache = (typeof window !== 'undefined')
            && /ios|iphone|ipod|ipad|android|blackberry|iemobile|mobile|webos|tablet|nexus/i
                .test((typeof navigator !== 'undefined')
                    && ((typeof navigator.userAgent === 'string') ? navigator.userAgent : ''));
    }

    return cache;
}
